import type { FullStore } from '../types'
import type { GlobalModal, ModalActions, ModalInput, ModalState } from './types'

const createDefaultModal = (id: number): GlobalModal => ({
    id,
    open: true,
    centered: true,
    closable: true,
    maskClosable: true,
    destroyOnClose: true,
})

type SetStore = (updater: (state: FullStore) => { modals: GlobalModal[]; nextId: number }) => void

export const createModalSlice = (set: SetStore): ModalState & ModalActions => ({
    modals: [],
    nextId: 0,

    addModal: (modal?: ModalInput) => {
        let createdId = -1

        set((state) => {
            createdId = state.nextId

            return {
                nextId: state.nextId + 1,
                modals: [...state.modals, { ...createDefaultModal(createdId), ...modal }],
            }
        })

        return createdId
    },

    removeModal: (targetId: number) =>
        set((state) => ({
            nextId: state.nextId,
            modals: state.modals.filter((modal) => modal.id !== targetId),
        })),

    closeModal: (targetId: number) =>
        set((state) => ({
            nextId: state.nextId,
            modals: state.modals.map((modal) => {
                if (modal.id === targetId) {
                    return { ...modal, open: false }
                }

                return modal
            }),
        })),

    clearAllModals: () =>
        set((state) => ({
            nextId: state.nextId,
            modals: [],
        })),

    updateModal: (targetId: number, updates: ModalInput) =>
        set((state) => ({
            nextId: state.nextId,
            modals: state.modals.map((modal) => {
                if (modal.id === targetId) {
                    return { ...modal, ...updates }
                }

                return modal
            }),
        })),
})
